import React, { useState } from 'react';
import "./styles.scss";

const ImageModal = ({ src, alt }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <div className='modal-element'>
      <img className='modal-element-image' src={src} alt={alt} onClick={openModal} />
      {isOpen && (
        <div className="modal">
          <div className="modal-content">
            <span className="close" onClick={closeModal}>&times;</span>
            <img className="modal-image" src={src} alt={alt} />
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageModal;
